export default __webpack_public_path__ + "static/media/avvaru-srinivas.4f2e383c.png";